export const state = {
    unidadeMedida: {},
    unidadesMedidas: [],
    modalExcluirUnidadeMedida: false,
    modalCadastrarUnidadesMedida: false,
}

export default {}